export const initialState = () => ({
  files: []
})
